<template>

    <!--Wrapper - Outer-->

    <div class="wrapper outer">
        <div class="wrapper inner">

            <!--Page-->

            <div class="page">

                <!--Content-->

                <div class="content">

                    <!--Login Page-->

                    <div class="login-page">

                        <div class="page-wrapper primary">

                            <!--Page Body - Primary-->

                            <section class="section page-body primary">

                                <!--Wizard-->

                                <div class="wizard">

                                    <!--Login Form - Primary-->

                                    <section class="section login-form primary">
                                        <div class="section-wrapper primary">

                                            <!--Header Section-->

                                            <div class="login-form-header">
                                                <div class="header-logo">
                                                    <div class="logo">
                                                        <img src="assets/images/logo/logo-escolarai-a.svg" />
                                                    </div>
                                                </div>
                                                <div class="header-background">
                                                    <div class="background">
                                                        <img src="assets/images/root/login-form-primary-header-background-1.png" />
                                                    </div>
                                                </div>
                                            </div>

                                            <!--Content Section-->

                                            <div class="login-form-content">
                                                <div class="content-wrapper primary">
                                                    <div class="content-text">
                                                        <div class="title">
                                                            <h2>
                                                                Que bom que você voltou!
                                                            </h2>
                                                        </div>
                                                    </div>
                                                    <div class="content-form">
                                                        <div class="form-group">
                                                            <div class="form-label">
                                                                <label>
                                                                    E-mail
                                                                </label>
                                                            </div>
                                                            <div class="form-input">
                                                                <input type="email" class="form-control" v-model="user" placeholder="Digite seu e-mail"/>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="form-label">
                                                                <label>
                                                                    Senha
                                                                </label>
                                                            </div>
                                                            <div class="form-input">
                                                                <input type="password" class="form-control" v-model="password" placeholder="Digite sua senha"/>
                                                            </div>
                                                            <div class="form-link">
                                                                <div class="link">
                                                                    <a class="link-form" href="/esqueci-senha">
                                                                        Esqueci minha senha
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-button">
                                                            <div class="button">
                                                                <button type="button" class="btn btn-block btn-form" @click="handleLogin">
                                                                    Entrar
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>   
                                        </div>
                                    </section>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import login from '@/utils/login';

export default {
    components: {},
    data() {
        return {
            user: '',
            password: ''
        };
    },
    computed: {
        ...mapState(['user'])
    },
    methods: {
        ...mapActions(['login', 'storeToken', 'storeRefreshToken', 'storeUser']),
        async handleLogin() {
            try {
                const payload = {
                    username: this.user,
                    password: this.password
                };
                const response = await login.login(payload);
                this.storeToken({token: response.access_token});
                this.storeUser({user: response.user});
                this.$router.push('/tela-principal');
            } catch (error) {
                console.error('Erro ao fazer login:', error);
            }
        }
    }
};
</script>

<style lang="scss">
.wizard .login-form.primary .login-form-content .content-wrapper.primary .content-form .form-button .button .btn-form {
    display: block;
    width: 100% !important;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    text-transform: uppercase;
    padding: .65rem 1rem;
    color: #ffffff;
    background-color: #34a5e4;
}
</style>